import { ClearConnectionResults } from "../../../Contracts";
export function unsubscribe(store, conn, r) {
    const x = store.clearConnection(r);
    if (conn.isConnectedSync() &&
        x !== ClearConnectionResults.RemovedConnection &&
        x !== ClearConnectionResults.QueryNotFound) {
        conn.send({
            name: "Unsubscribe",
            params: { id: x }
        });
    }
    return x;
}
//# sourceMappingURL=Unsubscribe.js.map